// Implements: F-IDN-012, F-UIX-009
/** P2: the login's «¿Olvidaste tu contraseña?», at the end of the password label row (v3 `forgot`). */

import type { ReactElement } from "react";
import { Link } from "react-router";

import { useTranslation } from "../../../shared/i18n";
import styles from "./Recovery.module.css";

/** The public request page (`/recuperar`). */
export const RECOVERY_PATH = "/recuperar";

export function ForgotPasswordLink(): ReactElement {
  const { t } = useTranslation();
  return (
    <Link to={RECOVERY_PATH} className={styles.forgot}>
      {t("auth.login.forgot")}
    </Link>
  );
}
